export default __webpack_public_path__ + "static/media/values.3e40de7d.svg";